import React from 'react'
import { BlogListItem } from './BlogListItem'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import StarIcon from '../../../static/svg/star.svg'
import ClockIcon from '../../../static/svg/wall-clock.svg'
import DifficultyIcon from '../../../static/svg/speedometer.svg'
import ServesIcon from '../../../static/svg/dinner.svg'
import InstagramIcon from '../../../static/svg/icons_insta.svg'
import LinkedinIcon from '../../../static/svg/icons_linkedin.svg'
import TwitterIcon from '../../../static/svg/icons_twitter.svg'
import { ArticleActions } from './articles/ArticleActions'

const BlogList = ({ data }) => {
  const { edges } = data.allMdx
  return (
    <>
      <div className="container blog-list-container">
        <BlogSideBlock />
        <div className="blog-list">
          {edges.map(({ node }) => {
            return (
              <BlogListItem
                {...node.frontmatter}
                excerpt={node.excerpt}
                slug={node.slug}
                readingTime={node.fields.readingTime.text}
                key={node.slug}
              />
            )
          })}
        </div>
      </div>
    </>
  )
}

const BlogSideBlock = (props) => {
  const { slug, author, title } = props
  const data = useStaticQuery(
    graphql`
      query {
        testImage: file(
          extension: { regex: "/(jpg)|(jpeg)|(png)/" }
          name: { eq: "pyry3" }
        ) {
          childImageSharp {
            fluid(maxWidth: 200, maxHeight: 130, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  )
  const imageSource = data.testImage.childImageSharp.fluid
  const getBlockContent = () => {
    if (slug && slug.includes('food')) {
      return (
        <>
          <div className="rating-container">
            <div className="star-rating-container">
              <StarIcon />
              <StarIcon />
              <StarIcon />
              <StarIcon />
              <StarIcon />
            </div>
            <p className="ratings-amount">Ratings: 102</p>
          </div>
          <div className="prep-time">
            <div>
              <ClockIcon style={{ fill: '#2c2c2c' }} />
            </div>
            <div>
              <div>
                <div>Prep time</div>
                <div>15 mins</div>
              </div>
              <div>
                <div>Cooking time</div>
                <div>25 mins</div>
              </div>
            </div>
          </div>
          <div className="prep-time">
            <div>
              <DifficultyIcon />
            </div>
            <div>
              <div>
                <div>Difficulty</div>
                <div>3/5</div>
              </div>
            </div>
          </div>
          <div className="prep-time">
            <div>
              <ServesIcon />
            </div>
            <div>
              <div>
                <div>Serves</div>
                <div>4 person</div>
              </div>
            </div>
          </div>
        </>
      )
    } else if (typeof slug === 'undefined') {
      return (
        <>
          <h2>Welcome to my blog!</h2>
          <a href="/" className="blog-date">
            Suggest a topic
          </a>
          <div className="blog-preview-img">
            <Img fluid={imageSource} />
          </div>
          <ul className="socials-follow">
            <li>
              <a
                href="https://instagram.com/pyrypalosaari"
                target="_blank"
                rel="noreferrer noopener"
                aria-label="Instagram"
              >
                <InstagramIcon />
              </a>
            </li>
            <li>
              <a
                href="https://twitter.com/pyrypalosaari"
                target="_blank"
                rel="noreferrer noopener"
                aria-label="Twitter"
              >
                <TwitterIcon />
              </a>
            </li>
            <li>
              <a
                href="https://twitter.com/pyrypalosaari"
                target="_blank"
                rel="noreferrer noopener"
                aria-label="Linkedin"
              >
                <LinkedinIcon />
              </a>
            </li>
          </ul>
          <a href="/" className="blog-follow">
            Subscribe
          </a>
        </>
      )
    } else {
      return (
        <>
          <h2>{title}</h2>
          <div className="blog-leftblock-author">
            Author: <b>{author}</b>
          </div>
          <ArticleActions slug={slug} />
          <div className="blog-preview-img">
            <Img fluid={imageSource} />
          </div>
          <ul className="socials-follow">
            <li>
              <a
                href="https://instagram.com/pyrypalosaari"
                target="_blank"
                rel="noreferrer noopener"
                aria-label="Instagram"
              >
                <InstagramIcon />
              </a>
            </li>
            <li>
              <a
                href="https://twitter.com/pyrypalosaari"
                target="_blank"
                rel="noreferrer noopener"
                aria-label="Twitter"
              >
                <TwitterIcon />
              </a>
            </li>
            <li>
              <a
                href="https://twitter.com/pyrypalosaari"
                target="_blank"
                rel="noreferrer noopener"
                aria-label="Linkedin"
              >
                <LinkedinIcon />
              </a>
            </li>
          </ul>
          <a href="/" className="blog-follow">
            Subscribe
          </a>
        </>
      )
    }
  }
  return (
    <div className="left-block-sticky">
      <div className="sticky-container">{getBlockContent()}</div>
    </div>
  )
}

export { BlogList, BlogSideBlock }
